//import DeleteIcon from '@mui/icons-material/Delete';
import {default as DownloadIcon} from '@mui/icons-material/Download';

export default DownloadIcon;